import React, {Component} from 'react'
import {Button, Descriptions, Form, Input, notification, Radio, Select} from "antd";
import {
    getUserListForDropbox, saveOrUpdateMallUser
} from '../../request'
import {getmd5} from "../../http/globalMethod";
const financialDeptList = [
    {label:"产品中心",value:1},
    {label:"供应链中心",value:2},
    {label:"环境建设中心-财务",value:3},
    {label:"环境建设中心-京东",value:4},
    {label:"环境建设中心-人力行政",value:5},
    {label:"环境建设中心-战略",value:6},
    {label:"环境建设中心-战略第三方",value:7},
    {label:"门店-新业务",value:8},
    {label:"用户推广中心-渠道",value:9},
    {label:"用户运营中心-京东POP",value:10},
    {label:"用户运营中心-天猫",value:11},
    {label:"用户运营中心-微信",value:12},
]
const platFormList = [
    {
        "platformId": '1',
        "platformName": "乐纯微信商城"
    },
    {
        "platformId": '2',
        "platformName": "乐纯APP",
    },
    {
        "platformId": '3',
        "platformName": "乐纯PCWEB"
    },
    {
        "platformId": '4',
        "platformName": "乐纯小程序"
    },
    {
        "platformId": '5',
        "platformName": "乐纯WAP"
    }
]

export default class SysUserInfo extends Component {
    formRef = React.createRef();
    state={
        userDropList:[]
    }
    setFormParam = (param)=>{
        this.formRef.current.setFieldsValue(param)
    }
    resetPassword = ()=>{
        //重置密码为123456
        if(this.props.userInfo&&this.props.userInfo.userId){
            this.handleSubmit({userId:this.props.userInfo.userId,password:getmd5('123456')})
        }
    }
    handleSubmit = (values)=>{
        console.log(values)
            saveOrUpdateMallUser({...values}).
            then(res=>{
                notification.success({
                    message: '操作成功',
                });
                this.props.handleSaveUserInfo(values.userId)

            })
    }
    componentDidMount() {
        //下拉用户列表
        // getUserListForDropbox().then(res=>{
        //     this.setState({
        //         userDropList:res
        //     })
        // })
    }

    render(){
        return (
            <Form
                ref={this.formRef}
                initialValues={this.props.userInfo}
                onFinish={this.handleSubmit}>
                <div style={{textAlign:'right',marginBottom:5}}>
                    <Form.Item>
                        <Button htmlType={'submit'} size={'small'} danger type="primary">保存</Button>
                    </Form.Item>
                </div>

                <Descriptions
                    size={'small'} bordered column={{ xs:1,sm:1,md:1,lg:1,xl: 1,xxl:2}}
                    labelStyle={{width:120,fontSize:12}}
                >
                    <Descriptions.Item label={<><span style={{color:'red'}}>*</span> 用户登录名</>}>
                        <Form.Item
                            label="userId"
                            name="userId"
                            hidden
                        >
                            <Input autoComplete="off" />
                        </Form.Item>
                        <Form.Item
                            name="userName"
                            rules={[{ required: true, message: '请输入用户登录名' }]}
                        >
                            <Input autoComplete="off" placeholder="请输入用户登录名"/>
                        </Form.Item>
                    </Descriptions.Item>
                    <Descriptions.Item label={<><span style={{color:'red'}}>*</span> 用户昵称</>}>
                        <Form.Item
                            name="userNick"
                            rules={[{ required: true, message: '请输入用户昵称' }]}
                        >
                            <Input placeholder="请输入用户昵称" />
                        </Form.Item>
                    </Descriptions.Item>
                    <Descriptions.Item label="手机号码">
                        <Form.Item
                            name="mobile"
                        >
                            <Input autoComplete="off" placeholder="请输入手机号码" />
                        </Form.Item>
                    </Descriptions.Item>
                    <Descriptions.Item
                        label="LEADER">
                        <Form.Item
                            name="leader"
                        >
                            <Select
                                allowClear
                                showSearch
                                placeholder="选择leader"
                                fieldNames={{label: 'USER_NAME', value: 'USER_ID'}}
                                filterOption={(input, option) =>
                                    (option?.USER_NAME ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                                options={this.props.userDropList}
                            />
                        </Form.Item>
                    </Descriptions.Item>
                    <Descriptions.Item
                        label="所属钉钉部门">
                        {this.props.userInfo?this.props.userInfo.dingdingDeptId:''}
                    </Descriptions.Item>
                    <Descriptions.Item
                        label="观远账号">
                        <Form.Item
                            name="guanyuanAccount"
                        >
                            <Input autoComplete="off" placeholder="请输入观远账号" />

                        </Form.Item>
                    </Descriptions.Item>
                    <Descriptions.Item
                        label="是否财务口径管理">
                        <Form.Item
                            name="isFinancialAdmin"
                        >
                            <Radio.Group>
                                <Radio value={1}>是</Radio>
                                <Radio value={0}>否</Radio>
                            </Radio.Group>
                        </Form.Item>
                    </Descriptions.Item>
                    <Descriptions.Item
                        label="财务口径所属部门">
                        <Form.Item
                            name="financialDeptId"
                        >
                            <Select
                                allowClear
                                showSearch
                                placeholder="选择财务口径所属部门"
                                fieldNames={{label: 'label', value: 'value'}}
                                filterOption={(input, option) =>
                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                                options={financialDeptList}
                            />
                        </Form.Item>
                    </Descriptions.Item>
                    <Descriptions.Item
                        label="离职后是否可评分">
                        <Form.Item
                            name="evalStatus"
                        >
                            <Radio.Group>
                                <Radio value={1}>可以</Radio>
                                <Radio value={0}>不可以</Radio>
                            </Radio.Group>
                        </Form.Item>
                    </Descriptions.Item>
                    <Descriptions.Item
                        label="是否允许离职后领券">
                        <Form.Item
                            name="cashStatus"
                        >
                            <Radio.Group disabled={this.props.userInfo&&this.props.userInfo.status==1?true:false}>
                                <Radio value={1}>允许</Radio>
                                <Radio value={0}>不允许</Radio>
                            </Radio.Group>
                        </Form.Item>
                    </Descriptions.Item>
                    <Descriptions.Item
                        label="所属公司">
                        <Form.Item
                            name="platformGroupId"
                        >
                            <Select  placeholder="请选择所属公司">
                                <Select.Option value={0}>全部</Select.Option>
                                <Select.Option value={1000}>乐纯</Select.Option>
                            </Select>
                        </Form.Item>
                    </Descriptions.Item>
                    <Descriptions.Item
                        label="所属平台">
                        <Form.Item
                            name="platformId">
                            <Select
                                mode="multiple"
                                allowClear
                                showSearch
                                placeholder="选择所属平台"
                                fieldNames={{label: 'platformName', value: 'platformId'}}
                                filterOption={(input, option) =>
                                    (option?.platformName ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                                options={platFormList}
                            />
                        </Form.Item>
                    </Descriptions.Item>
                    <Descriptions.Item
                        label="状态">
                        <Form.Item
                            name="status"
                        >
                            <Radio.Group buttonStyle={'solid'}>
                                <Radio.Button value={1}>有效</Radio.Button>
                                <Radio.Button value={-1}>无效</Radio.Button>
                            </Radio.Group>
                        </Form.Item>
                    </Descriptions.Item>
                    <Descriptions.Item label="密码">
                        {
                            this.props.userInfo&&this.props.userInfo.userId?
                                <Button style={{margin:'0 10px'}} danger={true} onClick={this.resetPassword}>重置用户登录密码</Button>
                                :''
                        }
                        <span style={{color:'#999999',fontSize:'10px'}}>（* 初始密码123456)</span>
                    </Descriptions.Item>
                </Descriptions>
            </Form>
        )
    }
}